// tslint:disable:jsx-no-lambda
import { Position } from '@blueprintjs/core'
import React, { Component } from 'react'
import { I18n } from 'react-i18next'
import { Route, RouteComponentProps, Switch } from 'react-router-dom'

import { loadModule } from 'modules/module-loader'
import { GuardedRoute } from 'modules/router'
import { SignalRConnectionProvider } from 'modules/signal-r'

import './app.scss'
import './shared/components/form.scss'

import { NewAspireRoute } from '../new/NewAspireRoute'
import { GAinit } from './analytics'
import { initTracking } from './tracking'
import { AppAside } from './app-aside'
import { links } from './app.links'
import { Auth, CurrentUser, Login, Logout, NotAuthorized, User } from './auth'
import { Lookup, NotFound } from './core'
import DateFnsProvider from './core/date-fns.provider'
import { Layout, Toasterer } from './shared'
import { initTracking } from './tracking'

// lazy loaded modules
const AdminModule = loadModule(() => System.import('./admin'))
const FrontFaceModule = loadModule(() => System.import('./front-face'))
const ReportsModule = loadModule(() => System.import('./reports'))

// GA initialization
GAinit()
initTracking()

export class App extends Component {
  render() {
    return (
      <main>
        <Toasterer position={Position.TOP_RIGHT} />
        <Switch>
          <Route path={links.auth.home()} component={Login} />
          <Route path={links.auth.notAuthorized()} component={NotAuthorized} />
          <Route path={links.auth.logout()} component={Logout} />
          <Route path={links.misc.notFound()} component={NotFound} />
          <Route component={MainModules} />
          <NewAspireRoute message={'app'} />
        </Switch>
      </main>
    )
  }
}

class MainModules extends Component<RouteComponentProps<{}>> {
  render() {
    return (
      <Auth {...this.props}>
        <Lookup langCode="en-US">
          <CurrentUser>
            {(user: User) => (
              <I18n>
                {(t) => (
                  <SignalRConnectionProvider>
                    <Layout>
                      {{
                        aside: (
                          <AppAside
                            user={user}
                            // onPostFeedback={this.handlePostFeedback}
                            t={t}
                            {...this.props}
                          />
                        ),
                        body: (
                          <Switch>
                            <GuardedRoute
                              path={links.admin.home()}
                              component={AdminModule}
                              guards={[DateFnsProvider]}
                            />
                            <GuardedRoute
                              path={links.reports.home()}
                              component={ReportsModule}
                              guards={[DateFnsProvider]}
                            />
                            <GuardedRoute
                              path={links.frontFace.home()}
                              component={FrontFaceModule}
                              guards={[DateFnsProvider]}
                            />
                          </Switch>
                        ),
                      }}
                    </Layout>
                  </SignalRConnectionProvider>
                )}
              </I18n>
            )}
          </CurrentUser>
        </Lookup>
      </Auth>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/app.tsx